import http from "./httpService";
class UserService {
  static getData(userId, sessionId) {
    const myPromise = new Promise((resolve, reject) => {
      let endpoint = process.env.REACT_APP_MULESOFT_HOST + "/api/users/" + userId;
      let clientId = process.env.REACT_APP_AUTH_CLIENT_ID;
          
          var getUserToken = JSON.parse(localStorage.getItem("okta-token-storage"))
          const getUserAccessToken = getUserToken.accessToken;
          const updatedUserToken = getUserAccessToken.accessToken;

      http
        .get(endpoint, { headers: { 
        'token': updatedUserToken,
        'client_id': clientId

     } })
        .then((response) => {
          const user = response.data;
          resolve(user);
        })
        .catch((error) => {
          reject(error);
        });
    });
    return myPromise;
  }
  static updateData(userId, sessionId, isAgreed) {
    const myPromise = new Promise((resolve, reject) => {
      let endpoint = process.env.REACT_APP_MULESOFT_HOST + "/api/users/" + userId;
      
      let clientUpdateId = process.env.REACT_APP_AUTH_CLIENT_ID;
          
      var getUserToken = JSON.parse(localStorage.getItem("okta-token-storage"))
      const getUserAccessUpdateToken = getUserToken.accessToken;
      const getUpdatedUserToken = getUserAccessUpdateToken.accessToken;

      const timeStamp = new Date().toISOString();
      const headers = { 
        'token': getUpdatedUserToken,
        'client_id': clientUpdateId

     };
      const data = { isConsentagreed: isAgreed, consentdateTime: timeStamp };
      http
        .patch(endpoint, data, { headers: headers })
        .then((response) => {
          const user = response.data;
          resolve(user);
        })
        .catch((error) => {
          reject(error);
        });
    });
    return myPromise;
  }
}
export default UserService;
